import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";
import { FaStar, FaRegStar } from "react-icons/fa";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<FaStar key={i} className="star filled" />);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<FaStar key={i} className="star half" />);
      } else {
        stars.push(<FaRegStar key={i} className="star empty" />);
      }
    }
    return stars;
  };

  return (
    <div className="shop main">
      <Header />

      <div className="shop-hero">
        <div className="hero-content">
          <h1 className="hero-title">A Match Made for Mischief</h1>
          <p className="hero-subtitle">For every way they play</p>
        </div>
      </div>

      <div className="shop-content">
        <div className="products-section">
          <div className="section-header">
            <h2 className="section-title">Best Sellers</h2>
            <p className="section-subtitle">
              Tried, tested, and loved by pets everywhere.
            </p>
          </div>

          <div className="products-grid">
            {productData.map((product) => (
              <div key={product.id} className="product-card">
                <Link
                  onClick={toTop}
                  to={`/shopDetails/${product.id}`}
                  className="product-image-link"
                >
                  <div className="product-image-wrapper">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="product-image"
                    />
                  </div>
                </Link>
                <div className="product-info">
                  <span className="product-category">{product.category}</span>
                  <Link
                    onClick={toTop}
                    to={`/shopDetails/${product.id}`}
                    className="product-name-link"
                  >
                    <h3 className="product-name">{product.name}</h3>
                  </Link>
                  <div className="product-rating">
                    <div className="stars">
                      {renderStars(parseFloat(product.rating))}
                    </div>
                    <span className="rating-number">{product.rating}</span>
                    <span className="review-count">({product.reviews})</span>
                  </div>
                  <p className="product-price">${product.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Shop;
